<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19xhmO2/images/cover.jpg?1692923894343" alt="This image is the cover for the book Jack and the Wild Life, The Berenson Schemes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jack and the Wild Life, The Berenson Schemes
      </h1>
      <p class="bookDescription body article font2">
        <p>After a wild plan by his parents left Jack stranded in the Caribbean, the Berenson family decided to lay out some rules. Jack's mom and dad agreed they wouldn't take so many risks. Jack agreed he'd try to live life without worrying quite so much. Then Jack's parents thought up another get-rich-quick scheme.<br/><br/> Now the family's driving around Kenya. An animal attack is about to send Jack up a tree?alone, with limited supplies. As Jack attempts to outsmart a ferocious honey badger and keep away from an angry elephant, he'll have plenty of time to wonder if the Berenson Family Decision-Making Rules did enough to keep him out of trouble.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Doan, Ivica Stevanovic
      </h2>
      
      <p class="authorDescription body article">Lisa Doan received a master's degree in writing for children and young adults from Vermont College of Fine Arts. As a professional vagabond, she has traveled extensively through Africa and Asia and lived on a Caribbean island for eight years. Her variety of professions have included Master Scuba Diving Instructor, New York City headhunter, Owner/Chef of a Chinese restaurant, television show Set Medic and Deputy Prothonotary of a county court. She wrote her first book during a Caribbean slow season while waiting for restaurant customers. She currently lives in Pennsylvania with a Great Dane who stares her down for biscuits.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A division of Lerner Publishing Group, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5f7e1f68